import _definePage_default_0 from '/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/login.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/password/forgot.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/password/reset.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/activities',
    /* internal name: '/activities' */
    /* no component */
    children: [
      {
        path: '',
        name: '/activities/',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/activities/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/countries',
    /* internal name: '/countries' */
    /* no component */
    children: [
      {
        path: '',
        name: '/countries/',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/countries/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/create',
    /* internal name: '/create' */
    /* no component */
    children: [
      {
        path: 'battle-card',
        name: '/create/battle-card',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/create/battle-card.vue'),
        /* no children */
      },
      {
        path: 'success-story',
        name: '/create/success-story',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/create/success-story.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/database',
    /* internal name: '/database' */
    /* no component */
    children: [
      {
        path: '',
        name: '/database/',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/database/index.vue'),
        /* no children */
      },
      {
        path: 'battle-card/:id',
        name: '/database/battle-card.[id]',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/database/battle-card.[id].vue'),
        /* no children */
      },
      {
        path: 'in-review',
        name: '/database/in-review',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/database/in-review.vue'),
        /* no children */
      },
      {
        path: 'success-story/:id',
        name: '/database/success-story.[id]',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/database/success-story.[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/edit',
    /* internal name: '/edit' */
    /* no component */
    children: [
      {
        path: 'admin',
        /* internal name: '/edit/admin' */
        /* no component */
        children: [
          {
            path: 'battle-card/:id',
            name: '/edit/admin/battle-card.[id]',
            component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/edit/admin/battle-card.[id].vue'),
            /* no children */
          },
          {
            path: 'success-story/:id',
            name: '/edit/admin/success-story.[id]',
            component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/edit/admin/success-story.[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'battle-card/:id',
        name: '/edit/battle-card.[id]',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/edit/battle-card.[id].vue'),
        /* no children */
      },
      {
        path: 'success-story/:id',
        name: '/edit/success-story.[id]',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/edit/success-story.[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/industries',
    /* internal name: '/industries' */
    /* no component */
    children: [
      {
        path: '',
        name: '/industries/',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/industries/index.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
    {
      path: '/login',
      name: '/login',
      component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/login.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  {
    path: '/password',
    /* internal name: '/password' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'forgot',
          name: '/password/forgot',
          component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/password/forgot.vue'),
          /* no children */
        },
        _definePage_default_2
      ),
      _mergeRouteRecord(
        {
          path: 'reset',
          name: '/password/reset',
          component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/password/reset.vue'),
          /* no children */
        },
        _definePage_default_3
      )
    ],
  },
  {
    path: '/review',
    /* internal name: '/review' */
    /* no component */
    children: [
      {
        path: '',
        name: '/review/',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/review/index.vue'),
        /* no children */
      },
      {
        path: 'battle-card/:id',
        name: '/review/battle-card.[id]',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/review/battle-card.[id].vue'),
        /* no children */
      },
      {
        path: 'success-story/:id',
        name: '/review/success-story.[id]',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/review/success-story.[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/submitted',
    /* internal name: '/submitted' */
    /* no component */
    children: [
      {
        path: '',
        name: '/submitted/',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/submitted/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/technology-trends',
    /* internal name: '/technology-trends' */
    /* no component */
    children: [
      {
        path: '',
        name: '/technology-trends/',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/technology-trends/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/users',
    /* internal name: '/users' */
    /* no component */
    children: [
      {
        path: '',
        name: '/users/',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/users/index.vue'),
        /* no children */
      },
      {
        path: ':id/edit',
        name: '/users/[id].edit',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/users/[id].edit.vue'),
        /* no children */
      },
      {
        path: 'create',
        name: '/users/create',
        component: () => import('/home/forge/application-database.balluff.com/releases/20260921205021/resources/js/pages/users/create.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

